// extracted by mini-css-extract-plugin
export default {"full_content":"signing-external-page_full_content__Oqjpu","container_style":"signing-external-page_container_style__955mJ"};